import React from 'react';
import {
  Box,
  Container,
  Typography,
  AppBar,
  Toolbar,
  Button,
  Stack,
  Paper,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <Box sx={{ backgroundColor: '#fafafa', minHeight: '100vh' }}>
      {/* ヘッダー */}
      <AppBar position="static" sx={{ backgroundColor: '#fff', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
        <Container maxWidth="lg">
          <Toolbar sx={{ justifyContent: 'space-between' }}>
            <Typography variant="h6" component="div" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
              マンション家計簿
            </Typography>
            <Stack direction="row" spacing={2}>
              <Button color="primary" onClick={handleBackToHome}>
                ホームに戻る
              </Button>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>

      {/* プライバシーポリシー内容 */}
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold" color="primary" textAlign="center">
          プライバシーポリシー
        </Typography>
        
        <Typography variant="body1" color="text.secondary" textAlign="center" sx={{ mb: 4 }}>
          最終更新日：2025年8月16日
        </Typography>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            1. 基本方針
          </Typography>
          <Typography variant="body1" paragraph>
            マンション家計簿（以下「当サービス」）は、ユーザーの個人情報の保護を重要視し、個人情報の保護に関する法律（個人情報保護法）を遵守し、適切な取り扱いを行います。
          </Typography>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            2. 収集する情報
          </Typography>
          <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3 }}>
            2.1 個人情報
          </Typography>
          <Typography variant="body1" paragraph>
            当サービスでは、以下の個人情報を収集する場合があります：
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <Typography component="li" variant="body1">メールアドレス</Typography>
            <Typography component="li" variant="body1">表示名</Typography>
            <Typography component="li" variant="body1">組織名・住所（管理組合情報）</Typography>
          </Box>

          <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3 }}>
            2.2 財務情報
          </Typography>
          <Typography variant="body1" paragraph>
            管理組合の収支管理のために、以下の財務情報を収集します：
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <Typography component="li" variant="body1">収支データ（金額、カテゴリ、取引日等）</Typography>
            <Typography component="li" variant="body1">アップロードされたCSVファイルの内容</Typography>
          </Box>

          <Typography variant="h6" component="h3" gutterBottom sx={{ mt: 3 }}>
            2.3 利用情報
          </Typography>
          <Typography variant="body1" paragraph>
            サービス改善のために、以下の利用情報を自動的に収集する場合があります：
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <Typography component="li" variant="body1">IPアドレス</Typography>
            <Typography component="li" variant="body1">ブラウザ情報</Typography>
            <Typography component="li" variant="body1">アクセス日時</Typography>
            <Typography component="li" variant="body1">利用状況（ページビュー等）</Typography>
          </Box>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            3. 情報の利用目的
          </Typography>
          <Typography variant="body1" paragraph>
            収集した情報は、以下の目的で利用します：
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <Typography component="li" variant="body1">サービスの提供・運営</Typography>
            <Typography component="li" variant="body1">ユーザーサポート</Typography>
            <Typography component="li" variant="body1">サービスの改善・開発</Typography>
            <Typography component="li" variant="body1">利用規約違反への対応</Typography>
            <Typography component="li" variant="body1">重要なお知らせの配信</Typography>
          </Box>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            4. 情報の共有・開示
          </Typography>
          <Typography variant="body1" paragraph>
            当サービスは、以下の場合を除き、収集した個人情報を第三者に提供することはありません：
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <Typography component="li" variant="body1">ユーザーの同意がある場合</Typography>
            <Typography component="li" variant="body1">法令に基づく場合</Typography>
            <Typography component="li" variant="body1">人の生命、身体または財産の保護のために必要がある場合</Typography>
            <Typography component="li" variant="body1">サービス提供に必要な業務委託先への提供（適切な管理の下で行います）</Typography>
          </Box>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            5. データの保存と削除
          </Typography>
          <Typography variant="body1" paragraph>
            • 個人情報は、利用目的の達成に必要な期間のみ保存します
          </Typography>
          <Typography variant="body1" paragraph>
            • アカウント削除の依頼があった場合、合理的な期間内にデータを削除します
          </Typography>
          <Typography variant="body1" paragraph>
            • バックアップデータについても、定期的に削除を行います
          </Typography>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            6. セキュリティ
          </Typography>
          <Typography variant="body1" paragraph>
            当サービスは、個人情報を保護するために以下の対策を講じています：
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <Typography component="li" variant="body1">SSL/TLS暗号化通信</Typography>
            <Typography component="li" variant="body1">データベースの暗号化</Typography>
            <Typography component="li" variant="body1">アクセス制御とログ監視</Typography>
            <Typography component="li" variant="body1">定期的なセキュリティ監査</Typography>
          </Box>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            7. Cookieの使用
          </Typography>
          <Typography variant="body1" paragraph>
            当サービスでは、サービスの利便性向上のためにCookieを使用する場合があります。Cookieの使用を望まない場合は、ブラウザの設定で無効にすることができますが、一部機能が制限される可能性があります。
          </Typography>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            8. プライバシーポリシーの変更
          </Typography>
          <Typography variant="body1" paragraph>
            当サービスは、必要に応じてプライバシーポリシーを変更する場合があります。重要な変更については、サービス内でお知らせいたします。
          </Typography>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            9. お問い合わせ
          </Typography>
          <Typography variant="body1" paragraph>
            プライバシーポリシーに関するご質問やご要望がございましたら、お問い合わせフォームからお問い合わせください
          </Typography>
        </Paper>

        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <Button variant="contained" size="large" onClick={handleBackToHome}>
            ホームに戻る
          </Button>
        </Box>
      </Container>
    </Box>
  );
};